import './doc-list.css'

import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/modules/shared/components/ui/card'

import type { useDocs } from '../hooks/use-docs.hook'

type DocInterfaceProps = ReturnType<typeof useDocs>
export function DocInterface({ doc, isLoading }: DocInterfaceProps) {
  if (isLoading) {
    return <p>Carregando...</p>
  }
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-2xl font-bold text-primary">
          {doc?.title}
        </CardTitle>
      </CardHeader>
      <CardContent className="p-4 md:p-6">
        {doc?.items?.map((item) => (
          <div key={item.id} className="mb-6">
            <h2 className="font-bold text-lg mb-2">{item.title}</h2>
            <div
              className="px-8 custom-ol"
              dangerouslySetInnerHTML={{
                __html: item.description,
              }}
            />
          </div>
        ))}
      </CardContent>
    </Card>
  )
}
